import { render, staticRenderFns } from "./FleetItem.vue?vue&type=template&id=4eabeeb2&scoped=true&"
import script from "./FleetItem.vue?vue&type=script&lang=js&"
export * from "./FleetItem.vue?vue&type=script&lang=js&"
import style0 from "./FleetItem.vue?vue&type=style&index=0&id=4eabeeb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eabeeb2",
  null
  
)

export default component.exports